module.exports = __webpack_public_path__ + "img/female-anatomy.4cc6d32c.png";